/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_VoteInputs */

const en_us2_community_vote = /** @type {(inputs: Community_VoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want this`)
};

const pt_br2_community_vote = /** @type {(inputs: Community_VoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quero`)
};

const es_419_community_vote = /** @type {(inputs: Community_VoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo quiero`)
};

const pt_pt2_community_vote = /** @type {(inputs: Community_VoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quero`)
};

const fr_fr2_community_vote = /** @type {(inputs: Community_VoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je veux`)
};

const de_de2_community_vote = /** @type {(inputs: Community_VoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Will ich`)
};

const it_it2_community_vote = /** @type {(inputs: Community_VoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo voglio`)
};

/**
* | output |
* | --- |
* | "I want this" |
*
* @param {Community_VoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_vote = /** @type {((inputs?: Community_VoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_VoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_vote(inputs)
	if (locale === "es-419") return es_419_community_vote(inputs)
	if (locale === "pt-PT") return pt_pt2_community_vote(inputs)
	if (locale === "fr-FR") return fr_fr2_community_vote(inputs)
	if (locale === "de-DE") return de_de2_community_vote(inputs)
	if (locale === "it-IT") return it_it2_community_vote(inputs)
	return en_us2_community_vote(inputs)
});
export { community_vote as "community.vote" }